<div class="modal-header" #changePassword>
  <h1 id="modal-title" class="modal-title">{{ "profile.change_password" | translate }}</h1>
  <button ngbAutofocus class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" ngbAutofocus>
  @if (creatingNewFenderPassword) {
    <div class="m-b-20">
      {{ "login.password_policy_update_message" | translate }}
    </div>
  }
  @if (creatingNewFenderPassword) {
    <div class="form-group">
      <label class="control-label mb-0" for="new_password_confirm">{{ "profile.enter_new_password" | translate }}</label>
      <input
        [type]="passwordVisible ? 'text' : 'password'"
        class="form-control"
        [(ngModel)]="newFenderPassword"
        (keyup)="checkPassword()"
        (blur)="passwordBlur()"
        (focus)="passwordFocus()"
        maxlength="128"
        id="new_password"
        autocomplete="new-password"
        required
      />
      <div class="d-flex align-items-center m-t-5">
        @if (passwordPasses) {
          <fa-icon icon="check-circle" class="t-16 m-r-5 c-green"></fa-icon>
        } @else if (showPasswordError) {
          <fa-icon icon="times-circle" class="t-16 m-r-5 c-lred"></fa-icon>
        }
        <small class="text-muted">{{ "profile.password_min" | translate }}</small>
      </div>
    </div>
    <div class="form-group">
      <label class="control-label mb-0" for="new_password_confirm">Confirm your new password*</label>
      <input
        [type]="passwordVisible ? 'text' : 'password'"
        class="form-control"
        [(ngModel)]="newFenderPasswordConfirm"
        maxlength="128"
        id="new_password_confirm"
        autocomplete="new-password"
        required
      />
    </div>
  }
  @if (!creatingNewFenderPassword) {
    @if (!code) {
      <div class="form-group">
        <label class="control-label mb-0" for="old_password">{{ "profile.current_password" | translate }}*</label>
        <input [type]="passwordVisible ? 'text' : 'password'" class="form-control" [(ngModel)]="passwordArgs.old_password" id="old_password" autocomplete="current-password" required />
      </div>
    }
    <div class="form-group" [class.m-t-50]="!code">
      <label class="control-label mb-0" for="new_password">{{ "profile.new_password" | translate }}*</label>
      <input
        [type]="passwordVisible ? 'text' : 'password'"
        class="form-control"
        [(ngModel)]="passwordArgs.new_password"
        (keyup)="checkPassword()"
        (blur)="passwordBlur()"
        (focus)="passwordFocus()"
        maxlength="128"
        id="new_password"
        autocomplete="new-password"
        aria-describedby="validation_message"
        required
      />
      <div class="d-flex align-items-center m-t-5" id="validation_message">
        @if (passwordPasses) {
          <fa-icon icon="check-circle" class="t-16 m-r-5 c-green"></fa-icon>
        } @else if (showPasswordError) {
          <fa-icon icon="times-circle" class="t-16 m-r-5 c-lred"></fa-icon>
        }
        <small class="text-muted">{{ "profile.password_min" | translate }}</small>
      </div>
    </div>
    <div class="form-group">
      <label class="control-label mb-0" for="new_password_confirm">{{ "profile.new_password_again" | translate }}*</label>
      <input
        [type]="passwordVisible ? 'text' : 'password'"
        class="form-control"
        [(ngModel)]="passwordArgs.new_password_confirm"
        maxlength="128"
        id="new_password_confirm"
        autocomplete="new-password"
        required
      />
    </div>
  }
  <div class="col-md-12">
    <myp-switch [active]="passwordVisible" label="Show passwords" [labelToRight]="true" (toggle)="passwordVisible = !passwordVisible"></myp-switch>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="submit()">
    {{ "general.submit" | translate }}
  </button>
  <button type="button" class="btn btn-blank" (click)="activeModal.close('Close click')">{{ "general.close" | translate }}</button>
</div>
